var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 19.5c0 2.209-1.791 4-4 4h-15c-2.209 0-4-1.791-4-4v-15c0-2.209 1.791-4 4-4h15c2.209 0 4 1.791 4 4v15zM.5 8.5h7.205M16.27 8.5h7.254"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 3.5h3v3h-3zM2.5 1v7.5M4.5.5v8M6.5.5v8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.bf4003fb9c607a1f386c13706fe72cd8.svg";
export { ForwardRef as ReactComponent };